import React, {} from 'react';
import Icon from '@ant-design/icons';

import { ReactComponent as arrowTop } from './svg/arrowTop.svg';
import { ReactComponent as headerDrawerClose } from './svg/headerDrawerCloseIcon.svg';
import { ReactComponent as headerDrawerSearch } from './svg/headerDrawerSearchIcon.svg';
import { ReactComponent as leftIcon } from './svg/leftIcon.svg';
import { ReactComponent as Plus } from './svg/Plus.svg';
import { ReactComponent as ServicePlus } from './svg/PlusService.svg';
import { ReactComponent as WayLeft } from './svg/way-left.svg';
import { ReactComponent as WayRight } from './svg/way-right.svg';
import { ReactComponent as WayBottom } from './svg/way-bottom.svg';
import { ReactComponent as WayTop } from './svg/way-top.svg';
import { ReactComponent as Search } from './svg/Search.svg';
import { ReactComponent as HeaderLogo } from './svg/headerLogo.svg';
import { ReactComponent as Reserve } from './svg/reserve.svg';



interface IconProps {
	className?: any;
	style?: any;
	title?: any;
	onClick?: any;
}

// logo 
export const HeaderLogoIcon = (props: IconProps) => <Icon component={HeaderLogo} {...props} />;

// 回到页头
export const ArrowTop = (props: IconProps) => <Icon component={arrowTop} {...props} />;
// 导航抽屉关闭右箭头
export const HeaderDrawerCloseIcon = (props: IconProps) => <Icon component={headerDrawerClose} {...props} />;
// 导航抽屉搜索
export const HeaderDrawerSearchIcon = (props: IconProps) => <Icon component={headerDrawerSearch} {...props} />;
// 返回左边icon
export const BackLeftIcon = (props: IconProps) => <Icon component={leftIcon} {...props} />;

// 关于我们，红色 “+” 号
export const PlusIcon = (props: IconProps) => <Icon component={Plus} {...props} />;

// 服务页面的 “+”号
export const ServicePlusIcon = (props: IconProps) => <Icon component={ServicePlus} {...props} />;

// 方向箭头，上下左右
export const WayLeftIcon = (props: IconProps) => <Icon component={WayLeft} {...props} />;
export const WayRightIcon = (props: IconProps) => <Icon component={WayRight} {...props} />;
export const WayBottomIcon = (props: IconProps) => <Icon component={WayBottom} {...props} />;
export const WayTopIcon = (props: IconProps) => <Icon component={WayTop} {...props} />;

// 搜索icon
export const SearchIcon = (props: IconProps) => <Icon component={Search} {...props} />;
// 图片占位icon
export const ReserveIcon = (props: IconProps) => <Icon component={Reserve} {...props} />;

